import MainLayout from '@/common/components/layouts/MainLayout';
import ShowIncidentParticipantsDataCard from '@/common/components/showIncidentParticipantsDataCard/ShowIncidentParticipantsDataCard';
import { getInitialVisitOwnerInformationQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getInitialVisitOwnerInformation/getInitialVisitOwnerInformationQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { Box, Flex } from 'styled-system/jsx';

export default () => {
  return (
    <MainLayout title="بیمه گذار - مالک" header="titleHeader">
      <InitialVisitOwnerOnlyShow />
    </MainLayout>
  );
};

const InitialVisitOwnerOnlyShow = () => {
  const { id } = useParams();
  const { data: ownerInformation } = useQuery(
    getInitialVisitOwnerInformationQueryOptions({ id: +id! }),
  );
  return (
    <Box pt={26}>
      <Flex direction="column" gap={16}>
        <ShowIncidentParticipantsDataCard
          title="اطلاعات فردی"
          data={ownerInformation?.transformedData?.personal_information ?? []}
        />
        <ShowIncidentParticipantsDataCard
          title="اطلاعات تماس"
          data={ownerInformation?.transformedData?.contact_information ?? []}
        />
      </Flex>
    </Box>
  );
};
